import React, {FC} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {useToggle} from '../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {KeyboardShortcuts} from '../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {InboxesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {PaletteContainer} from './paletteContainer';

/*
 * Props.
 */

interface PaletteCoordinatorProps {
  parameters: InboxesParameters;
}

/*
 * Component.
 */

export const PaletteCoordinator: FC<PaletteCoordinatorProps> = (props) => {
  const {parameters} = props;
  const [isOpen, toggle] = useToggle();

  return (
    <KeyboardShortcuts
      handlers={{
        [KeyboardActionsEnum.OPEN_PALETTE]: toggle,
      }}
    >
      {isOpen && <PaletteContainer parameters={parameters} onRequestClose={toggle} />}
    </KeyboardShortcuts>
  );
};
